<template>
	<div
		class="
			fixed
			inset-y-0
			right-0
			pl-10
			flex
			side-over
			z-50
			overflow-y-auto
		"
		style="width: 720px"
	>
		<div
			class="h-full w-full flex flex-col bg-white shadow-xl"
			style="min-height: 100vh; height: fit-content"
		>
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center">
						<img
							src="@/assets/images/icons/yellow-move.png"
							alt=""
						/>
						<div class="text-2xl font-bold text-neutral-700 ml-2">
							Đưa vào Thư viện nội bộ
						</div>
					</div>
					<div class="ml-3 h-7 flex items-center">
						<button
							type="button"
							class="
								rounded-md
								text-neutral-400
								hover:text-neutral-700
							"
							@click="$emit('close')"
						>
							<span class="sr-only">Close panel</span>
							<svg
								class="h-6 w-6"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								aria-hidden="true"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div class="mt-6 relative flex-1 px-4 sm:px-6">
				<div>
					<div>
						<div class="font-semibold text-neutral-600 mb-4">
							Chọn thư viện chuyển đến *
						</div>
						<div class="select-tabs mb-6">
							<Multiselect
								v-model="libSelected"
								deselect-label="Đã chọn"
								track-by="name"
								:options="
									libs?.map((s) => {
										return {
											nameSearch: toEnglish(s?.name),
											...s,
										};
									})
								"
								:searchable="true"
								label="nameSearch"
								:allow-empty="false"
								selectLabel=""
								placeholder="Chọn thư viện chuyển đến (*)"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
								<template v-slot:option="props">
									<div class="flex flex-nowrap items-center">
										<div>
											{{ props.option.name }}
										</div>
									</div>
								</template>
								<template v-slot:singleLabel="{ option }">
									<div
										class="
											flex flex-nowrap
											items-center
											font-medium
										"
									>
										<div>{{ option.name }}</div>
									</div>
								</template>
							</Multiselect>
						</div>
					</div>
					<div v-if="options.length">
						<div class="font-semibold text-neutral-600 mb-4">
							Chọn thư mục chuyển đến *
						</div>
						<div class="select-tabs mb-6">
							<Multiselect
								v-model="optionSelected"
								deselect-label="Đã chọn"
								track-by="name"
								:options="
									options?.map((s) => {
										return {
											nameSearch: toEnglish(s?.name),
											...s,
										};
									})
								"
								:searchable="true"
								label="nameSearch"
								:allow-empty="false"
								selectLabel=""
								placeholder="Chọn thư mục chuyển đến (*)"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
								<template v-slot:option="props">
									<div class="flex flex-nowrap items-center">
										<div>
											{{ props.option.name }}
										</div>
									</div>
								</template>
								<template v-slot:singleLabel="{ option }">
									<div
										class="
											flex flex-nowrap
											items-center
											font-medium
										"
									>
										<div>{{ option.name }}</div>
									</div>
								</template>
							</Multiselect>
						</div>
					</div>
					<div v-if="optionLevel.length">
						<div v-for="(o, index) in optionLevel" :key="index">
							<div class="font-semibold text-neutral-600 mb-4">
								Chọn thư mục chuyển đến *
							</div>
							<div class="select-tabs mb-6">
								<Multiselect
									v-model="optionLevelSelected[index]"
									deselect-label="Đã chọn"
									track-by="name"
									:options="
										o?.map((s) => {
											return {
												nameSearch: toEnglish(s?.name),
												...s,
											};
										})
									"
									:searchable="true"
									label="nameSearch"
									:allow-empty="false"
									selectLabel=""
									placeholder="Chọn thư mục chuyển đến (*)"
								>
									<template #noResult>
										Không tìm thấy kết quả
									</template>
									<template v-slot:option="props">
										<div
											class="
												flex flex-nowrap
												items-center
											"
										>
											<div>
												{{ props.option.name }}
											</div>
										</div>
									</template>
									<template v-slot:singleLabel="{ option }">
										<div
											class="
												flex flex-nowrap
												items-center
												font-medium
											"
										>
											<div>{{ option.name }}</div>
										</div>
									</template>
								</Multiselect>
							</div>
						</div>
					</div>
				</div>
				<div
					class="my-4 flex justify-end font-semibold text-neutral-400"
				>
					<div>
						Đã chọn {{ selected.length }}
						{{ isLib ? 'thư mục' : 'mục tiêu' }}
					</div>
				</div>
				<div class="mb-10">
					<div class="shadow-sm sm:rounded-2xl overflow-hidden">
						<div class="__record__table scroll-bar">
							<div class="sm:rounded-t-2xl w-fit min-w-full">
								<table
									class="
										min-w-full
										divide-y
										text-neutral-200
										rounded-2xl
									"
								>
									<thead
										class="bg-neutral-100 h-16 rounded-2xl"
									>
										<tr>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													w-16
													whitespace-nowrap
												"
											>
												STT
											</th>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												<div
													class="
														flex
														items-center
														gap-1
														justify-between
														cursor-pointer
													"
												>
													{{
														isLib
															? 'Tên thư mục'
															: 'Tên mục tiêu'
													}}
												</div>
											</th>
											<th
												v-if="!isLib"
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												<div
													class="
														flex
														items-center
														gap-1
														justify-between
														cursor-pointer
													"
												>
													lĩnh vực
													<svg
														width="16"
														height="16"
														viewBox="0 0 16 16"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M7.99999 2.39999C8.21216 2.39999 8.41564 2.48428 8.56567 2.63431L10.9657 5.03431C11.2781 5.34673 11.2781 5.85326 10.9657 6.16568C10.6533 6.4781 10.1467 6.4781 9.8343 6.16568L7.99999 4.33136L6.16567 6.16568C5.85325 6.4781 5.34672 6.4781 5.0343 6.16568C4.72188 5.85326 4.72188 5.34673 5.0343 5.03431L7.4343 2.63431C7.58433 2.48428 7.78782 2.39999 7.99999 2.39999ZM5.0343 9.83431C5.34672 9.52189 5.85325 9.52189 6.16567 9.83431L7.99999 11.6686L9.8343 9.83431C10.1467 9.52189 10.6533 9.52189 10.9657 9.83431C11.2781 10.1467 11.2781 10.6533 10.9657 10.9657L8.56567 13.3657C8.25325 13.6781 7.74672 13.6781 7.4343 13.3657L5.0343 10.9657C4.72188 10.6533 4.72188 10.1467 5.0343 9.83431Z"
															fill="#94A3B8"
														/>
													</svg>
												</div>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(goal, i) in selected"
											:key="goal.id"
											:class="
												i % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="text-neutral-700"
										>
											<td
												class="
													px-6
													py-4
													whitespace-nowrap
													text-neutral-700
												"
											>
												<div class="ml-2">
													{{ i + 1 }}
												</div>
											</td>
											<td
												class="
													px-6
													py-4
													text-neutral-700
												"
											>
												<div
													class="
														flex
														items-center
														gap-2
													"
													v-html="goal?.name"
												></div>
											</td>
											<td
												v-if="!isLib"
												class="
													px-6
													py-4
													text-neutral-700
												"
												style="width: 300px"
											>
												<div
													class="
														flex
														items-center
														gap-2
													"
												>
													{{
														skills.find(
															(s) =>
																s.id ===
																goal.skill_id
														)?.name || '-'
													}}
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="px-6 py-4 border-t border-yellow-100">
				<div class="flex justify-end">
					<div>
						<button
							:disabled="
								!optionSelected ||
								(optionLevelSelected.length &&
									!optionLevelSelected[
										optionLevel.length - 1
									])
							"
							type="button"
							class="button-p text-center w-32"
							@click="submit"
						>
							Xác nhận
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Multiselect from '@suadelabs/vue3-multiselect';
import { toEnglish } from '@/helper/toEnglish';
import { $api } from '@/services';

export default {
	name: 'MoveToLibrary',

	components: { Multiselect },

	props: {
		selected: {
			type: Array,
			required: true,
		},

		skills: {
			type: Array,
			required: true,
		},

		isOpen: {
			type: Boolean,
			required: true,
		},

		isLib: {
			type: Boolean,
			required: true,
		},
	},

	watch: {
		isOpen: {
			immediate: true,
			handler(value) {
				this.libs = [];
				this.libSelected = null;
				this.options = [];
				this.optionSelected = null;
				this.optionLevel = [];
				this.optionLevelSelected = [];

				if (value && !this.libs.length) {
					this.fetchAllGoalLib();
				}
			},
		},

		libSelected: {
			immediate: true,
			deep: true,
			handler(value) {
				this.options = [];
				this.optionLevel = [];
				this.optionSelected = [];
				if (value) {
					this.fetchGoalFolders(value.id);
				}
			},
		},

		optionSelected: {
			immediate: true,
			deep: true,
			handler(value) {
				this.optionLevel = [];
				this.optionLevelSelected = [];
				if (
					value &&
					value.children?.length &&
					!value.children[0].is_goal
				) {
					if (!this.optionLevel.length) {
						this.optionLevel.push([]);
						this.optionLevelSelected.push(null);
					}
					this.optionLevel[0] = value.children;
					this.optionLevelSelected[0] = null;
				}
			},
		},

		optionLevelSelected: {
			immediate: true,
			deep: true,
			handler(value) {
				if (
					value &&
					value.length &&
					value[value.length - 1]?.children &&
					value[value.length - 1]?.children.length &&
					!value[value.length - 1]?.children[0].is_goal
				) {
					this.optionLevel.push(value[value.length - 1].children);
				}
			},
		},
	},

	computed: {
		id() {
			return this.$route?.params?.id || '';
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		folders() {
			return this.$store.getters.foldersSelected;
		},

		childFolder() {
			return this.$store.getters.childFoldersSelected;
		},
	},

	data() {
		return {
			libs: [],
			libSelected: null,
			options: [],
			optionSelected: null,
			optionLevel: [],
			optionLevelSelected: [],
		};
	},

	methods: {
		toEnglish,
		async submit() {
			try {
				await $api.goal.copyGoalsReference({
					library_item_ids: this.selected.map((i) => i.id),
					to_goal_library_id: this.libSelected?.id,
					to_library_item_id:
						this.optionLevelSelected[
							this.optionLevelSelected.length - 1
						]?.id || this.optionSelected?.id,
				});
				this.$emit('updated');
				this.$store.dispatch('setAlertMessage', {
					message: 'Đưa vào thư viện nội bộ thành công',
				});
			} catch (err) {
				this.$store.dispatch('setAlertMessage', {
					message: err?.response?.data?.errors.join('<br/>'),
					type: 'danger',
				});
			}
		},

		async fetchAllGoalLib() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchAllGoalLib({}, this.isAdmin);
				this.libs = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.isLoading = false;
			}
		},

		async fetchGoalFolders(id) {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchAllGoalFolders(id, {}, this.isAdmin);
				this.options = data.filter((i) => !i.is_goal);
			} catch (e) {
				console.log(e);
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.isDataLoading = false;
			}
		},
	},
};
</script>
